<div class="otp-container">
  <input
    *ngFor="let item of otp; let i = index"
    type="tel"
    maxlength="1"
    class="otp-box"
    [id]="'otp-' + i"
    [(ngModel)]="otp[i]"
    (input)="onInput($event, i)"
    (keydown)="onKeyDown($event, i)"
  />
</div>
